// extracted by mini-css-extract-plugin
export default {"info-box":"info-box","infoBox":"info-box","icon":"icon","info-content":"info-content","infoContent":"info-content","info-text":"info-text","infoText":"info-text"};